/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * @module enervee_utils.cookies
 */
CookiesService.$inject = [
    '$cookies',
    'UtilService',
];
function CookiesService(
    $cookies,
    UtilService
) {
    var _pub = {};
    var oneSecond = 1000;
    var oneMinute = 60 * oneSecond;
    var oneHour = 60 * oneMinute;
    var oneDay = 24 * oneHour;
    var oneYear = 365 * oneDay;
    var unitsInMilliseconds = {
        milliseconds: 1,
        seconds: oneSecond,
        minutes: oneMinute,
        hours: oneHour,
        days: oneDay,
        years: oneYear,
    };
    var defaultCookieSettings = {
        auto_renew: false,
        max_age: {
            years: 1,
        },
    };
    var cookieSettings = UtilService.getSiteSetting('cookie_settings', {});
    cookieSettings = Object.assign({}, defaultCookieSettings, cookieSettings);
    var cookiesToIgnore = ['csrftoken', 'sessionid'];

    _pub.get = $cookies.get;
    _pub.set = set;
    _pub.remove = $cookies.remove;
    _pub.getExpirationDate = getExpirationDate;
    initializeCookies();

    /**
     * Sets cookie's value
     *
     * @param {String} cookieName - Name of the cookie we are saving
     * @param {Object} value - Value of the cookie we are saving
     * @param {null|Object} cookieOptions - Specific cookie options for the cookie we are saving
     * @param cookieOptions.{Date} expires - The expiration date and time for the cookie we are saving
     */
    function set(cookieName, value, cookieOptions=null) {

        if (!cookieOptions) {
            cookieOptions = getCookieOptions();
        }

        if (typeof value !== 'string') {
            return $cookies.putObject(cookieName, value, cookieOptions);
        }
        return $cookies.put(cookieName, value, cookieOptions);
    }

    /**
     * Gets the options for setting cookie values
     *
     * @return {Object}
     */
    function getCookieOptions() {
        return {
            expires: getExpirationDate(cookieSettings.max_age),
        };
    }

    /**
     * Gets the expiration date for cookies.
     *
     *
     *
     * @param {Object} config A configuration object for determining the expiration date,
     * calculated using the sum of all the units listed in the object. See below params for
     * valid units.
     * @param {Number} [config.milliseconds]
     * @param {Number} [config.seconds]
     * @param {Number} [config.minutes]
     * @param {Number} [config.hours]
     * @param {Number} [config.days]
     * @param {Number} [config.years]
     * @return {String}
     */
    function getExpirationDate(config) {
        var now = new Date();
        var expirationDate = new Date();
        var ageInMilliseconds = 0;
        angular.forEach(config, function (value, unit) {
            if (unitsInMilliseconds[unit]) {
                ageInMilliseconds += unitsInMilliseconds[unit] * value;
            }
        });
        expirationDate.setTime(now.getTime() + ageInMilliseconds);
        return expirationDate.toGMTString();
    }

    /**
     * Initialization logic for cookies
     */
    function initializeCookies() {
        if (cookieSettings.auto_renew) {
            // For all the cookies already set, renew them
            angular.forEach($cookies.getAll(), function (value, key) {
                if (cookiesToIgnore.indexOf(key) > -1) {
                    return;
                }
                _pub.set(key, value);
            });
        }
    }

    return _pub;
}

module.exports = CookiesService;
